const initialState = {
  active: false,
  title: '',
  resolve: null,
  reject: null,
  okText: 'Ok',
  cancelText: 'Annuler',
  selector: null,
  value: null,
  props: null
}

const state = Object.assign({}, initialState)

const mutations = {
  'ACTIVATE': (state, payload) => {
    Object.assign(state, payload)
  },
  'DEACTIVATE': (state) => {
    state = Object.assign(state, initialState)
  },
  'SET_VALUE': (state, payload) => {
    state.value = payload
  }
}

const actions = {
  select: ({ commit }, { title, selector, okText = initialState.okText, cancelText = initialState.cancelText, props = initialState.props }) => {
    let p = new Promise((resolve, reject) => {
      commit('ACTIVATE', {
        active: true,
        selector,
        title,
        resolve,
        reject,
        okText,
        cancelText,
        props
      })
    })

    p.finally(() => {
      commit('DEACTIVATE')
    })

    return p
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
